<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoFinance' :class="{scrollHide: isShowStoreBox}" ref="scrollBox">
    <div class="timeline-item red" v-for="(app,index) in data" :date-is="app.addtime_str" :key="index">
      <span class="title ">
        <span>{{app.cateTitleStr}} # {{app.moneyStr}}{{app.typeTitle}}</span>
      </span>
      <div class="huifu waiceng">
        <span class="content">
          {{app.contents}}
        </span>
        <div class="msg" style="margin: 0;">
          <abbr title="附件"><a target="_blank" :href="app.filepath">{{app.filename}}</a></abbr>
          <abbr title="附件"><a target="_blank" :href="app.filepath_b">{{app.filename_b}}</a></abbr>
          <abbr title="附件"><a target="_blank" :href="app.filepath_c">{{app.filename_c}}</a></abbr>
          <abbr title="附件"><a target="_blank" :href="app.filepath_d">{{app.filename_d}}</a></abbr>
        </div>
      </div>
      <span class="modifyBox btn btn-secondary btn-sm" @click="storeBoxFun(true,2,app.id)">改</span>
    </div>

    <div v-if="!is_empty">
      <div v-if='isLoading && !isSearchLoading' class='dynamicMessage'>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </div>
      <div v-if='isNodata' class='dynamicMessage'>
        — 没有更多了 —
      </div>
      <div v-if='isError' class='dynamicMessage'>
        — 请求失败 —
      </div>
    </div>
    <div class="emptyBox" v-if="is_empty && data.length===0">
      <i class="iconfont icon-kong"></i>
    </div>
    <div v-show="isShowStoreBox" class="traceStoreBoxModel">
      <div class="traceStoreBox">

        <div class="xuanzeBox mb-3">
          <div class="box">
            <el-cascader placeholder="入账类型" v-model="cateVal" :options="cateArr" clearable :props="{ expandTrigger: 'hover' }"></el-cascader>
          </div>
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">标题</span>
              </div>
              <input placeholder="入账标题" type="text" v-model="topicVal" class="form-control">
            </div>
          </div>
          <div class="box" style="margin: 0;">
            <div class="input-group">
              <input placeholder="入账日期" type="text" ref="timesNode" onclick="WdatePicker({isShowClear:false,readOnly:true,dateFmt:'yyyy-MM-dd HH:mm'})" class="form-control" readonly="">
            </div>
          </div>
        </div>

        <div class="xuanzeBox mb-3">
          <div class="box" style="flex:2;">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">金额</span>
              </div>
              <input placeholder="入账金额" type="text" v-model="moneyVal" class="form-control">
            </div>
          </div>
          <div class="box text-center">
            👉
          </div>
          <div class="box" style="flex:2;">
            <multiselect v-model="danweiVal" track-by="name" label="name" placeholder="单位" :options="danweiArr" :searchable="false"  :show-labels="false">
              <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
            </multiselect>
<!--            <div class="form-check form-check-inline">-->
<!--              <input v-model="type" class="form-check-input" type="radio" id="inlineRadio1" value="0">-->
<!--              <label class="form-check-label" for="inlineRadio1">人民币</label>-->
<!--            </div>-->
<!--            <div class="form-check form-check-inline">-->
<!--              <input v-model="type" class="form-check-input" type="radio" id="inlineRadio2" value="1">-->
<!--              <label class="form-check-label" for="inlineRadio2">美元</label>-->
<!--            </div>-->
<!--            <div class="form-check form-check-inline">-->
<!--              <input v-model="type" class="form-check-input" type="radio" id="inlineRadio3" value="2">-->
<!--              <label class="form-check-label" for="inlineRadio3">港币</label>-->
<!--            </div>-->
<!--            <div class="form-check form-check-inline" style="margin: 0;">-->
<!--              <input v-model="type" class="form-check-input" type="radio" id="inlineRadio4" value="3">-->
<!--              <label class="form-check-label" for="inlineRadio4">现金</label>-->
<!--            </div>-->
          </div>
        </div>

        <div class="biaodanBox mb-3">
          <div class="box">
            <uploader :options="options" @file-added="onFileAdded" @file-success="onFileSuccess" @file-error="onFileError" @file-removed="fileRemoved">
              <uploader-btn class="clearCss" :attrs="attrs">
                <div class="uploadBox">
                  <div :class="{'text-success':!!filename}" v-if="!isUploadLoading">{{filename?filename:'【附件】'}}</div>
                  <div v-else><i class='iconfont icon-jiazai xuanzhuan'></i> 上传中···</div>
                </div>
              </uploader-btn>
            </uploader>
            <span v-if="filename" @click="delFilename" class="badge badge-light">删</span>
          </div>
          <div class="box">
            <uploader :options="options" @file-added="onFileAdded" @file-success="onFileSuccessB" @file-error="onFileError" @file-removed="fileRemoved">
              <uploader-btn class="clearCss" :attrs="attrs">
                <div class="uploadBox">
                  <div :class="{'text-success':!!filename_b}" v-if="!isUploadLoadingB">{{filename_b?filename_b:'【附件】'}}</div>
                  <div v-else><i class='iconfont icon-jiazai xuanzhuan'></i> 上传中···</div>
                </div>
              </uploader-btn>
            </uploader>
            <span v-if="filename_b" @click="delFilenameB" class="badge badge-light">删</span>
          </div>
          <div class="box">
            <uploader :options="options" @file-added="onFileAdded" @file-success="onFileSuccessC" @file-error="onFileError" @file-removed="fileRemoved">
              <uploader-btn class="clearCss" :attrs="attrs">
                <div class="uploadBox">
                  <div :class="{'text-success':!!filename_c}" v-if="!isUploadLoadingC">{{filename_c?filename_c:'【附件】'}}</div>
                  <div v-else><i class='iconfont icon-jiazai xuanzhuan'></i> 上传中···</div>
                </div>
              </uploader-btn>
            </uploader>
            <span v-if="filename_c" @click="delFilenameC" class="badge badge-light">删</span>
          </div>
          <div class="box" style="margin: 0;">
            <uploader :options="options" @file-added="onFileAdded" @file-success="onFileSuccessD" @file-error="onFileError" @file-removed="fileRemoved">
              <uploader-btn class="clearCss" :attrs="attrs">
                <div class="uploadBox">
                  <div :class="{'text-success':!!filename_d}" v-if="!isUploadLoadingD">{{filename_d?filename_d:'【附件】'}}</div>
                  <div v-else><i class='iconfont icon-jiazai xuanzhuan'></i> 上传中···</div>
                </div>
              </uploader-btn>
            </uploader>
            <span v-if="filename_d" @click="delFilenameD" class="badge badge-light">删</span>
          </div>
        </div>

        <p class="content">注：PDF / 图片</p>

        <div class="textareaBox mb-3">
          <textarea class="form-control" aria-label="With textarea" v-model="contentsVal" placeholder="描述"></textarea>
        </div>
        <div class="anniuBox">
          <button type="button" @click.self="storeBoxFun(false)" class="btn btn-secondary btn-round">取消</button>
          <button type="button" v-if="btnTitle==='修改'" @click="submitDelFun()" class="btn btn-danger btn-round">
            <i v-if="isDelLoading" class='iconfont icon-jiazai xuanzhuan'></i> 删除
          </button>
          <button type="button" @click="submitFun()" class="btn btn-success btn-round">
            <i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> {{btnTitle}}
          </button>
        </div>
      </div>
    </div>
    <span v-if="!isShowStoreBox" @click="storeBoxFun(true,1)" class="tianjia btn btn-success btn-round">添加</span>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/types';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { apiCrmFinanceCatearr } from '../../../request/api';

export default {
  name: 'commonClientinfoFinance',
  props: ['token'],
  data() {
    return {
      isUploadLoading: false,
      isUploadLoadingB: false,
      isUploadLoadingC: false,
      isUploadLoadingD: false,
      filepath: '',
      filename: '',
      filepath_b: '',
      filename_b: '',
      filepath_c: '',
      filename_c: '',
      filepath_d: '',
      filename_d: '',
      attrs: {
        accept: 'image/jpeg,image/png,image/jpg,application/pdf',
      },

      isShowStoreBox: false,
      isSubmitLoading: false,
      isDelLoading: false,
      btnTitle: '',
      // 备忘队列
      memoData: [
        { id: 1, times: '2021-22-56 12:12:25', title: '这是一个备忘', content: '这是备注这是备注这是备注这是备注这是备注这是备注这是备注这是备注这是备注' },
      ],
      // 合同标题
      topicVal: '',
      // 合同备注
      contentsVal: '',
      str: '',
      // 合同金额
      moneyVal: '',

      // 分页
      data: [], // 数据队列
      allPage: 0, // 总页数
      allNumber: 0, // 总页数
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      // 加载中
      isSearchLoading: true,
      type: 0,

      cateVal: null,
      cateArr: [],

      danweiArr: [],
      danweiVal: null,
    };
  },
  computed: {
    ...mapGetters({
      localUser: types.GET_LOCALUSER,
    }),
    options() {
      return {
        target: process.env.IMAGE_UPLOAD_URL,
        testChunks: false,
        singleFile: true,
        chunkSize: 200 * 1024 * 1024,
        fileParameterName: 'UploadFormfile[imgFile]',
        query: {
          dir: 'crmfinance',
        },
        headers: {
          Authorization: this.localUser.token,
          Version: this.localUser.version,
        },
      };
    },
    submitData() {
      return {
        type: this.danweiVal.value,
        filename: this.filename,
        filepath: this.filepath,
        filename_b: this.filename_b,
        filepath_b: this.filepath_b,
        filename_c: this.filename_c,
        filepath_c: this.filepath_c,
        filename_d: this.filename_d,
        filepath_d: this.filepath_d,
        token: this.token,
        topic: this.topicVal,
        contents: this.contentsVal,
        str: this.str,
        cate_id: this.cateVal[1],
        money: this.moneyVal,
        addtime: this.$refs.timesNode.value,
      };
    },
  },
  methods: {
    delFilename() {
      this.filename = '';
      this.filepath = '';
    },
    delFilenameB() {
      this.filename_b = '';
      this.filepath_b = '';
    },
    delFilenameC() {
      this.filename_c = '';
      this.filepath_c = '';
    },
    delFilenameD() {
      this.filename_d = '';
      this.filepath_d = '';
    },
    onFileAdded(file) {
      // 判断文件大小
      const size = file.file.size;
      if (size > process.env.IMAGE_UPLOAD_SIZE) {
        file.pause();
        this.$message.showMsgBox({
          type: 'success',
          content: '文件过大',
        });
      }
    },
    onFileSuccess(rootFile, file, response, chunk) {
      // 上传选择后
      const result = JSON.parse(response);
      if (result.state === 200) {
        this.filepath = result.data.path;
        this.filename = result.data.name;
        this.$message.showMsgBox({
          type: 'success',
          content: '上传成功',
        });
      } else {
        this.$message.showMsgBox({
          type: 'error',
          content: result.message,
        });
      }
      this.isUploadLoading = false;
    },
    onFileSuccessB(rootFile, file, response, chunk) {
      // 上传选择后
      const result = JSON.parse(response);
      if (result.state === 200) {
        this.filepath_b = result.data.path;
        this.filename_b = result.data.name;
        this.$message.showMsgBox({
          type: 'success',
          content: '上传成功',
        });
      } else {
        this.$message.showMsgBox({
          type: 'error',
          content: result.message,
        });
      }
      this.isUploadLoadingB = false;
    },
    onFileSuccessC(rootFile, file, response, chunk) {
      // 上传选择后
      const result = JSON.parse(response);
      if (result.state === 200) {
        this.filepath_c = result.data.path;
        this.filename_c = result.data.name;
        this.$message.showMsgBox({
          type: 'success',
          content: '上传成功',
        });
      } else {
        this.$message.showMsgBox({
          type: 'error',
          content: result.message,
        });
      }
      this.isUploadLoadingC = false;
    },
    onFileSuccessD(rootFile, file, response, chunk) {
      // 上传选择后
      const result = JSON.parse(response);
      if (result.state === 200) {
        this.filepath_d = result.data.path;
        this.filename_d = result.data.name;
        this.$message.showMsgBox({
          type: 'success',
          content: '上传成功',
        });
      } else {
        this.$message.showMsgBox({
          type: 'error',
          content: result.message,
        });
      }
      this.isUploadLoadingD = false;
    },
    onFileError(file) {
      console.log(file, 'onFileError');
      // 上传选择后
      this.$message.showMsgBox({
        type: 'error',
        content: '上传失败',
      });
    },
    fileRemoved(file) {
      console.log(file, 'fileRemoved');
    },
    storeBoxFun(bool, type, str = '') {
      this.isShowStoreBox = bool;
      // 如果显示模态框
      if (bool) {
        // 添加
        if (type === 1) {
          this.topicVal = '';
          this.contentsVal = '';
          this.str = '';
          this.btnTitle = '添加';
          this.filepath = '';
          this.filename = '';
          this.filepath_b = '';
          this.filename_b = '';
          this.filepath_c = '';
          this.filename_c = '';
          this.filepath_d = '';
          this.filename_d = '';
          this.type = 0;
          this.moneyVal = '';
          this.cateVal = null;
          this.$refs.timesNode.value = '';
        }
        // 修改
        if (type === 2) {
          const info = this.data.find(app => app.id === str);

          this.topicVal = info.topic;
          this.type = info.type;
          this.contentsVal = info.contents;
          this.str = str;
          this.btnTitle = '修改';

          this.danweiVal = { value: info.type, name: info.typeTitle };

          if (info.filepath) {
            const fileInfo = new URL(info.filepath);
            this.filepath = fileInfo.pathname;
            this.filename = info.filename;
          } else {
            this.filepath = '';
            this.filename = '';
          }

          if (info.filepath_b) {
            const fileInfob = new URL(info.filepath_b);
            this.filepath_b = fileInfob.pathname;
            this.filename_b = info.filename_b;
          } else {
            this.filepath_b = '';
            this.filename_b = '';
          }

          if (info.filepath_c) {
            const fileInfoc = new URL(info.filepath_c);
            this.filepath_c = fileInfoc.pathname;
            this.filename_c = info.filename_c;
          } else {
            this.filepath_c = '';
            this.filename_c = '';
          }

          if (info.filepath_d) {
            const fileInfod = new URL(info.filepath_d);
            this.filepath_d = fileInfod.pathname;
            this.filename_d = info.filename_d;
          } else {
            this.filepath_d = '';
            this.filename_d = '';
          }


          this.moneyVal = info.money;
          this.$refs.timesNode.value = info.sign_time_str;
          if (info.cate_id) {
            this.cateVal = [info.cate_id_pid, info.cate_id];
          } else {
            this.cateVal = null;
          }
        }
      } else {
        this.str = '';


        this.btnTitle = '';
      }
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      }
    },
    // 初始化个人的
    initData(reload = false) {
      if (reload) {
        this.data = [];
        this.allPage = 0;
        this.page = 1;
        this.allNumber = 0;
        this.is_empty = false; // 是否为空数据(没有任何数据)
        this.isNodata = false; // 没有更多了
        this.isLoading = false; // 是否请求中
        this.isError = false; // 请求失败
        this.isSearchLoading = true; // 悬浮加载中
      }
      return resultCommons.apiCrmFinance(this, { page: this.page, token: this.token }, reload).then((ob) => {});
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = node.scrollHeight - node.scrollTop - node.clientHeight <= 150;
        console.log(bottomOfWindow);
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          this.initData();
        }
      };
    },
    submitFun() {
      console.log(this.submitData);
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 提交中
      this.isSubmitLoading = true;
      resultCommons.apiCrmFinanceStore(this, this.submitData).then((ob) => {
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 提交中
        this.isSubmitLoading = false;
        if (ob.state === 200) {
          const info = ob.data.info;
          if (ob.data.type === 'join') {
            // 加入
            this.data.unshift(info);
          } else {
            // 更新
            this.data.forEach((app, index) => {
              if (app.id === info.id) {
                this.data[index] = info;
              }
            });
          }
          // 隐藏box
          this.isShowStoreBox = false;
          // 提示
          this.$message.showMsgBox({
            type: 'success',
            content: ob.message,
          });
        } else {
          // 提示
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
        }
      });
    },
    submitDelFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 提交中
      this.isDelLoading = true;

      // 执行删除
      resultCommons.apiCrmFinanceDel(this, { str: this.str }).then((ob) => {
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 提交中
        this.isDelLoading = false;
        if (ob.state === 200) {
          // 隐藏box
          this.isShowStoreBox = false;
          this.data = this.data.filter(app => app.id !== this.str);
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
    initTages() {
      resultCommons.apiCrmFinanceCatearr(this, { str: this.str }).then((ob) => {
        if (ob.state === 200) {
          this.cateArr = ob.data;
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
      resultCommons.apiCrmfinancedanwei(this, {}).then((ob) => {
        if (ob.state === 200) {
          this.danweiArr = ob.data;
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
  },
  components: {
    Multiselect,
  },
  created() {
    this.initTages();
    // 初始化
    this.initData().then((app) => {
      this.isSearchLoading = false;
    });
  },
  mounted() {
    // 创建事件
    this.scroll(this, this.$refs.scrollBox);
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoFinance{
  flex: 1;
  overflow-y: auto;
  background: #FFFFFF;
  padding: 15px;
  .timeline-item{
    position: relative;
    .modifyBox{
      position: absolute;
      top: 20px;
      right: 0;
      display: none;
      border-radius: 8px;
    }
    &:hover{
      .modifyBox{
        display: block;
      }
    }
  }
  .huifu{
    .msg{
      abbr{
        display: block;

      }
    }
  }
  div.uploadBox{
    padding: 10px 5px;
    font-size: 12px;
  }
  div.emptyBox{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    i{
      font-size: 70px;
      color: rgba(0,0,0,0.1);
    }
  }
  div.lis{
    display: flex;
    margin-bottom: 15px;
    border-bottom: 1px dashed rgba(0,0,0,0.2);
    div.imgBox{
      margin-right: 10px;
      width: 60px;
      height: 60px;
      background: #343A40;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      i{
        font-size: 22px;
      }
    }
    &:hover{
    }
  }
  span.tianjia{
    position: absolute;
    display: inline-block;
    width: 90px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  }
  div.traceStoreBoxModel{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.1);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    div.traceStoreBox{
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
      padding: 30px 15px;
      background: #FFFFFF;
      div.biaodanBox{
        display: flex;
        div.box{
          width: 128px;
          margin-right: 10px;
          position: relative;
          &:last-child{
            margin: 0;
          }
          span.badge{
            position: absolute;
            top: 3px;
            right: -4px;
            cursor: pointer;
            &:hover{
              color: red;
            }
          }
        }
      }
      div.xuanzeBox{
        display: flex;
        flex-direction: row;
        div.box{
          margin-right: 6px;
          flex: 1;
          position: relative;
        }
        div.last{
          flex: 1;
          display: flex;
          align-items: center;
          margin: 0;
          div.form-group{
            margin: 0;
            .form-check{
              margin: 0;
            }
          }
        }
      }
      div.textareaBox{
        textarea{
          height: 90px;
          border-radius: 5px;
        }
      }
      div.anniuBox{
        text-align: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/finance.vue